module.exports = __webpack_public_path__ + "static/img/vanessavigier_circle150.26c859e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/vanessavigier_circle150.png
// module id = DVHi
// module chunks = 0